// import { fireSys } from '@/api/building'
const state = {
  //   buildingData: '',
  urgencyShow: null,
  urgencyPopShow: false
}
const mutations = {
  FIRESYS(state, data) {
    state.buildingData = data
  },
  urgencyVuex(state, urgencyShow) {
    state.urgencyShow = urgencyShow
  },
  urgencyPop(state, urgencyPopShow) {
    state.urgencyPopShow = urgencyPopShow
  }

}
const actions = {

}

export default {
  state,
  mutations,
  actions
}
